<template>
    <div>
        <Header title="Det optimala för dig" subtitle="Våra lediga uppdrag" :background="header_background"/>
        <div id="login_register" v-if="!mobile">
            <table>
                <tr>
                    <td>
                        <h1 class="underline">Lediga uppdrag</h1>
                        <p>
                            Vi publicerar regelbundet nya uppdrag vilket leder till nya möjligheter för dig. Det finns inget som hindrar dig från att fritt bläddra bland våra tillgängliga uppdrag tills du hittar något som passar dig perfekt.
                        </p>
                    </td>
                    <td align="right">
                        <div class="links">
                            <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200008d9247d871f43d0af1a" target="_blank" class="whole">
                                <div class="link">
                                    <table>
                                        <tr>
                                            <td>
                                                <i class="fas fa-sign-in-alt"></i>
                                            </td>
                                            <td>
                                                <span>Har du ett konto?</span>
                                                <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200008d9247d871f43d0af1a" target="_blank">Logga in</a>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </a>
                            <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank" class="whole">
                                <div class="link">
                                    <table>
                                        <tr>
                                            <td>
                                                <i class="fas fa-sign-in-alt"></i>
                                            </td>
                                            <td>
                                                <span>Ny användare?</span>
                                                <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank">Skapa konto</a>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </a>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div id="login_register" v-else>
            <h1 class="underline">Lediga uppdrag</h1>
            <p>
                Vi publicerar regelbundet nya uppdrag vilket leder till nya möjligheter för dig. Det finns inget som hindrar dig från att fritt bläddra bland våra tillgängliga uppdrag tills du hittar något som passar dig perfekt.
            </p>
            <div class="links">
                <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200008d9247d871f43d0af1a" target="_blank" class="whole">
                    <div class="link">
                        <table>
                            <tr>
                                <td>
                                    <i class="fas fa-sign-in-alt"></i>
                                </td>
                                <td>
                                    <span>Har du ett konto?</span>
                                    <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200008d9247d871f43d0af1a" target="_blank">Logga in</a>
                                </td>
                            </tr>
                        </table>
                    </div>
                </a>
                <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank" class="whole">
                    <div class="link">
                        <table>
                            <tr>
                                <td>
                                    <i class="fas fa-sign-in-alt"></i>
                                </td>
                                <td>
                                    <span>Ny användare?</span>
                                    <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank">Skapa konto</a>
                                </td>
                            </tr>
                        </table>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Footer from "./Footer";
import Header from "./Header";
import header_background from "../assets/img/helloquence-61189-unsplash.jpg"
export default {
    components: {Footer, Header},
        data() {
            return {
                mobile: window.mobilecheck(),
                header_background: header_background
            }
        },
  name: 'Uppdrag',
  props: {
    msg: String
  }
}
</script>

<style scoped>
    @import url("../assets/css/uppdrag.module.css");
</style>
